import { Spin } from 'antd'
import { Suspense } from 'react'
import type { RouteObject } from 'react-router'

import { RequireAuth } from './auth/RequireAuth'
import { AppLayout } from './layout/AppLayout'
import { HomeRoute } from './layout/HomeRoute'
import {
  AlertsPage,
  ApiDocsPage,
  ApiClientsPage,
  AuditLogsPage,
  CodecsPage,
  JobDetailPage,
  JobsPage,
  KeyPoolDetailPage,
  KeyPoolsPage,
  KeyProvidersPage,
  LegacyRequestsPage,
  LegacySettingsPage,
  MyStoragesPage,
  NodeDetailPage,
  NodesPage,
  ProfileDetailPage,
  ProfilesPage,
  QueueDetailPage,
  QueuesPage,
  RequestStatsPage,
  RunDetailPage,
  SettingsPage,
  StatsPage,
  StoragePage,
  StoragesPage,
  UsersPage,
  WatchPage,
} from './pages/lazy'
import { LoginPage } from './pages/LoginPage'
import { NotFoundPage } from './pages/NotFoundPage'

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  // Trang công khai: ngoài RequireAuth / AppLayout (ADR 0025), token trong URL fragment.
  {
    path: '/watch',
    element: (
      <Suspense fallback={<Spin size="large" style={{ display: 'block', margin: '20vh auto' }} />}>
        <WatchPage />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <HomeRoute /> },
      { path: 'jobs', element: <RequireAuth role="viewer" transcoder><JobsPage /></RequireAuth> },
      { path: 'jobs/:id', element: <RequireAuth role="viewer" transcoder><JobDetailPage /></RequireAuth> },
      { path: 'stats', element: <RequireAuth role="viewer" transcoder><StatsPage /></RequireAuth> },
      { path: 'queues', element: <RequireAuth role="viewer"><QueuesPage /></RequireAuth> },
      { path: 'queues/assignments', element: <RequireAuth role="viewer"><QueuesPage tab="assignments" /></RequireAuth> },
      { path: 'queues/rules', element: <RequireAuth role="viewer"><QueuesPage tab="rules" /></RequireAuth> },
      { path: 'queues/:id', element: <RequireAuth role="viewer"><QueueDetailPage /></RequireAuth> },
      { path: 'alerts', element: <RequireAuth role="viewer"><AlertsPage /></RequireAuth> },
      { path: 'profiles', element: <RequireAuth role="viewer" transcoder><ProfilesPage /></RequireAuth> },
      { path: 'profiles/:id', element: <RequireAuth role="viewer" transcoder><ProfileDetailPage /></RequireAuth> },
      { path: 'nodes', element: <RequireAuth role="viewer"><NodesPage /></RequireAuth> },
      { path: 'nodes/:id', element: <RequireAuth role="viewer"><NodeDetailPage /></RequireAuth> },
      { path: 'api-docs', element: <RequireAuth role="viewer" transcoder><ApiDocsPage /></RequireAuth> },
      { path: 'codecs', element: <RequireAuth role="viewer" transcoder><CodecsPage /></RequireAuth> },
      { path: 'my-storages', element: <RequireAuth role="viewer" transcoder transcoderOnly><MyStoragesPage /></RequireAuth> },
      { path: 'storage', element: <RequireAuth role="operator"><StoragePage /></RequireAuth> },
      { path: 'storage/browse', element: <RequireAuth role="admin"><StoragePage tab="browse" /></RequireAuth> },
      { path: 'storage/reconcile', element: <RequireAuth role="admin"><StoragePage tab="reconcile" /></RequireAuth> },
      { path: 'storage/policies', element: <RequireAuth role="operator"><StoragePage tab="policies" /></RequireAuth> },
      { path: 'storage/runs', element: <RequireAuth role="operator"><StoragePage tab="runs" /></RequireAuth> },
      { path: 'storage/runs/:id', element: <RequireAuth role="operator"><RunDetailPage /></RequireAuth> },
      { path: 'storages', element: <RequireAuth role="admin"><StoragesPage /></RequireAuth> },
      { path: 'drm', element: <RequireAuth role="admin"><KeyProvidersPage /></RequireAuth> },
      { path: 'key-pools', element: <RequireAuth role="admin"><KeyPoolsPage /></RequireAuth> },
      { path: 'key-pools/:id', element: <RequireAuth role="admin"><KeyPoolDetailPage /></RequireAuth> },
      { path: 'api-clients', element: <RequireAuth role="operator"><ApiClientsPage /></RequireAuth> },
      { path: 'legacy-requests', element: <RequireAuth role="operator"><LegacyRequestsPage /></RequireAuth> },
      { path: 'request-stats', element: <RequireAuth role="operator"><RequestStatsPage /></RequireAuth> },
      { path: 'legacy-settings', element: <RequireAuth role="admin"><LegacySettingsPage /></RequireAuth> },
      { path: 'users', element: <RequireAuth role="admin"><UsersPage /></RequireAuth> },
      { path: 'settings', element: <RequireAuth role="admin"><SettingsPage /></RequireAuth> },
      { path: 'audit-logs', element: <RequireAuth role="admin"><AuditLogsPage /></RequireAuth> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
